// Chakra imports
import { Portal, Box, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Text } from '@chakra-ui/react';
import Footer from 'components/footer/FooterAdmin.js';
// Layout components
import Navbar from 'components/navbar/NavbarAdmin.js';
import Sidebar from 'components/sidebar/Sidebar.js';
import { SidebarContext } from 'contexts/SidebarContext';
import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';
import {setBalance} from '@/store/festures/balanceSlice.js';
import routes from 'routes.js';
import useFetchData from '@/hooks/fetch.js'
import { getMainChart } from '@/api/login'
import baseStorage from 'store'

// Custom Chakra theme
export default function Dashboard(props) {
  const { ...rest } = props;
  const location = useLocation(); // 获取当前路由location
  const navigate = useNavigate(); // 用于路由跳转
  const fetchBalace = useFetchData({
    url: '/api/balance/detail',
    method: 'get'
  })
  // states and functions
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const { isOpen: isBalanceModalOpen, onOpen: onBalanceModalOpen, onClose: onBalanceModalClose } = useDisclosure();
  const [hasCheckedBalance, setHasCheckedBalance] = useState(false); // 防止重复弹窗
  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== '/admin/full-screen-maps';
  };
  const getActiveRoute = (routes) => {
    let activeRoute = 'Default Brand Text';
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbar(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].secondary;
        }
      }
    }
    return activeNavbar;
  };
  const getActiveNavbarText = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbarText(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbarText(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].messageNavbar;
        }
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((route, key) => {
      if (route.layout === '/admin') {
        return (
          <Route path={`${route.path}`} element={route.component} key={key} />
        );
      }
      if (route.collapse) {
        return getRoutes(route.items);
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = 'ltr';
  const { onOpen } = useDisclosure();
  document.documentElement.dir = 'ltr';

  const dispatch = useDispatch()
  
  // 获取余额数据的effect
  useEffect(() => {
    fetchBalace.then(res => {
      // alert(res)
      const balance = res.toFixed(2);
      dispatch(setBalance(balance));
      
      // 检查余额是否小于或等于-10，并且还没有检查过
      if (parseFloat(balance) <= -10 && !hasCheckedBalance) {
        onBalanceModalOpen();
        setHasCheckedBalance(true);
      }
    }).catch(() => {})
  }, [fetchBalace, dispatch, hasCheckedBalance, onBalanceModalOpen])

  // 监听路由变化，每次路由改变时请求getMainChart
  useEffect(() => {
    const fetchMainChart = async () => {
      try {
        console.log('路由已改变，正在刷新主图表数据...', location.pathname)
        const res = await getMainChart()
        baseStorage.set('mainChart', res)
        console.log('主图表数据已更新:', res)
      } catch (error) {
        console.log('获取主图表数据失败:', error)
      }
    }

    // 每次路由变化时调用
    fetchMainChart()
  }, [location.pathname]) // 依赖项为location.pathname，路由变化时触发

  // 处理跳转到余额充值页面
  const handleGoToRecharge = () => {
    onBalanceModalClose();
    navigate('/admin/recharge-balance');
  };

  return (
    <Box>
      <Box>
        <SidebarContext.Provider
          value={{
            toggleSidebar,
            setToggleSidebar,
          }}
        >
          <Sidebar routes={routes.filter(r => r.layout === '/admin')} display="none" {...rest} />
          <Box
            float="right"
            minHeight="100vh"
            height="100%"
            overflow="auto"
            position="relative"
            maxHeight="100%"
            w={{ base: '100%', xl: 'calc( 100% - 290px )' }}
            maxWidth={{ base: '100%', xl: 'calc( 100% - 290px )' }}
            transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            transitionDuration=".2s, .2s, .35s"
            transitionProperty="top, bottom, width"
            transitionTimingFunction="linear, linear, ease"
          >
            <Portal>
              <Box>
                <Navbar
                  onOpen={onOpen}
                  logoText={'Horizon UI Dashboard PRO'}
                  brandText={getActiveRoute(routes)}
                  secondary={getActiveNavbar(routes)}
                  message={getActiveNavbarText(routes)}
                  fixed={fixed}
                  {...rest}
                />
              </Box>
            </Portal>
            {getRoute() ? (
              <Box
                mx="auto"
                p={{ base: '20px', md: '30px' }}
                pe="20px"
                minH="100vh"
                pt="50px"
              >
                <Routes>
                  {getRoutes(routes)}
                  <Route
                    path="/"
                    element={<Navigate to="/admin/default" replace />}
                  />
                </Routes>
              </Box>
            ) : null}
            {/* <Box>
              <Footer />
            </Box> */}
          </Box>
        </SidebarContext.Provider>
      </Box>

      {/* 余额透支提醒弹窗 */}
      <Modal isOpen={isBalanceModalOpen} onClose={onBalanceModalClose} isCentered size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize="xl" fontWeight="bold" color="orange.500">
            温馨提醒
          </ModalHeader>
          <ModalBody>
            <Text fontSize="md" lineHeight="1.8" mb="4">
              您好！我们检测到您的账户余额当前处于透支状态，为确保您能持续享受无间断的服务，建议您尽快补足账户余额。
            </Text>
            <Text fontSize="md" lineHeight="1.8">
              同时，为进一步规范账户管理并保障服务质量，我司将于<Text as="span" fontWeight="bold" color="red.500">2025年12月15日</Text>起实施新的透支规则：账户最多可透支<Text as="span" fontWeight="bold" color="red.500">10元</Text>，若余额透支超过该限额，将暂停为您提供服务。
            </Text>
            <Text fontSize="md" lineHeight="1.8" mt="4" color="gray.600">
              感谢您的理解与支持！
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onBalanceModalClose}>
              稍后处理
            </Button>
            <Button colorScheme="brand" onClick={handleGoToRecharge}>
              余额充值
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}
